import { jsx as _jsx } from "react/jsx-runtime";
import { TypographyText } from '../_core';
import { cx } from '../../../utils/cx';
import styles from '../typography.module.css';
/**
 * Eyebrow / overline label. Renders `<span>`.
 *
 * 12px sans 600 with 0.04em letter-spacing. Natural case by default.
 * Pass `case="upper"` for uppercase eyebrow contexts.
 *
 * Do not override fontSize, fontFamily, lineHeight, fontWeight, or
 * letterSpacing via style prop.
 */
export function Overline({ case: textCase = 'natural', children, style, className, ...rest }) {
    return (_jsx(TypographyText, { as: "span", roleClassName: cx(styles.overline, textCase === 'upper' && styles.upper), className: className, style: style, ...rest, children: children }));
}
//# sourceMappingURL=Overline.js.map